import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import Productos from './ViewModal/Productos';
import Referencias from './ViewModal/Referencias';
import MetodoPago from './ViewModal/MetodoPago';

import Footer from './ViewModal/Footer';

const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class ViewModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Comprobante"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaStr}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    />
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.tipoCambio}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '40%' }}
                                        value={this.props.formValues.serie}
                                    />
                                    <Input readOnly
                                        style={{ width: '60%' }}
                                        value={this.props.formValues.documento}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Días / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.diasVencimiento}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaVencimientoStr}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Moneda">
                                <Input readOnly
                                    value={this.props.formValues.nombreMoneda}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Lista de Precio">
                                <Input readOnly
                                    value={this.props.formValues.nombreListaPrecio}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Establecimiento">
                                <Input readOnly
                                    value={this.props.formValues.nombreEstablecimiento}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Almacén">
                                <Input readOnly
                                    value={this.props.formValues.nombreAlmacen}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Vendedor">
                                <Input readOnly
                                    value={this.props.formValues.nombreVendedor}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Cliente">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.numeroDocumentoCliente}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.nombreCliente}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Dirección">
                                <Input readOnly
                                    value={this.props.formValues.direccionCliente}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div
                            className={
                                this.props.formValues.flagEmpresaGrifo ? "col-md-9" : "col-md-12"
                            }
                        >
                            <Form.Item label="Observación">
                                <Input readOnly
                                    value={this.props.formValues.observacion}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3" style={{ display: this.props.formValues.flagEmpresaGrifo ? '' : 'none' }}>
                            <Form.Item label="N° Placa">
                                <Input readOnly
                                    value={this.props.formValues.numeroPlaca}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <Productos
                                        dataSource={this.props.formValues.detalles}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <Referencias
                                        dataSource={this.props.formValues.referencias}
                                    />
                                </TabPane>
                                <TabPane tab="Método de Pago" key="4">
                                    <MetodoPago
                                        dataSource={this.props.formValues.metodosPagos}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <Footer
                        formValues={this.props.formValues}
                    />
                </Form>
            </Modal>
        );
    }
}